export const FEATURE_CASH_REGISTER_EDIT_TRANSLATIONS = {
  printf: $localize`:@@cashRegister.field.printf:Print! F - vecchio formato`,
  italRetail: $localize`:@@cashRegister.field.italRetail:ItalRetail - vecchio formato`,
  custom: $localize`:@@cashRegister.field.custom:Custom - vecchio formato`,
  epson_fp_81_80: $localize`:@@cashRegister.field.epson_fp_81_80:Epson FP-90III RT - FP-81III - vecchio formato`,
  printf_7: $localize`:@@cashRegister.field.printf_7:Print! F - 7.0`,
  italRetail_7: $localize`:@@cashRegister.field.italRetail_7:ItalRetail - 7.0`,
  custom_7: $localize`:@@cashRegister.field.custom_7:Custom - 7.0`,
  epson_fp_81_90_7: $localize`:@@cashRegister.field.epson_fp_81_90_7:Epson FP-90III RT - FP-81III - 7.0`,
};
